module.exports = __webpack_public_path__ + "img/textD.d93f2454.png";